
// 汇总标题映射
const summaryMap = {
  receivableNum: '需还款',
  receivedNum: '已还款',
  surplusNum: '未还款',
}
const leaseStatusOption = {
  1500: '发车待验车',
  2500: '履约中',
  3500: '退车待验车',
  4500: '订单待核算',
  5000: '费用待结算',
  5500: '已关闭',
}

const config = function (customerType) {
  const columns = [
    {
      name: 'receivableId',
      columnProps: {
        label: '应收ID',
        prop: 'receivableId',
        width: '100px',
      },
    },
    {
      name: 'customerName',
      columnProps: {
        label: '客户名称',
        prop: 'customerName',
        width: 110,
      },
    },
    {
      name: 'brandName',
      columnProps: {
        label: '品牌',
        prop: 'brandName',
      },
    },
    {
      name: 'seriesName',
      columnProps: {
        label: '车系',
        prop: 'seriesName',
      },
    },
    {
      name: 'modelName',
      columnProps: {
        label: '车型',
        prop: 'modelName',
        width: '160px',
      },
    },
    {
      name: 'plateNo',
      columnProps: {
        label: '车牌号',
        prop: 'plateNo',
        width: '100px',
      },
    },
    {
      name: 'orderState',
      columnProps: {
        label: '租赁状态',
        prop: 'orderState',
        width: '100px',
      },
      getText: ({ row }) => {
        return leaseStatusOption[row.orderState] || '--'
      },
    },
    {
      name: 'receivedDeposit',
      columnProps: {
        label: '实收押金（当前）',
        prop: 'receivedDeposit',
        width: '150px',
      },
      columnHeaderTooltip: '当前实收押金：一次性已交押金或分期付款时，显示已付款之和',
    },
    {
      name: 'arrears',
      columnProps: {
        label: '逾期欠款（截至上月底）',
        prop: 'arrears',
        width: '200px',
      },
      columnHeaderTooltip: '逾期欠款（截至上月底）：截至当前月的前一个月的月底该车逾期欠款的金额',
    },
    {
      name: 'totalAmount',
      columnProps: {
        label: '应交租金（当前）',
        prop: 'totalAmount',
        width: '150px',
      },
    },
    {
      name: 'receivedAmount',
      columnProps: {
        label: '实收租金（当前）',
        prop: 'receivedAmount',
        width: '150px',
      },
    },

    {
      name: 'accumulatedArrears',
      columnProps: {
        label: '欠租金额',
        prop: 'accumulatedArrears',
        width: '150px',
      },
      columnHeaderTooltip: '对应用户每个应收单所欠金额',
    },
    // {
    //   name: 'surplusAmount',
    //   columnProps: {
    //     label: '欠租金额',
    //     prop: 'surplusAmount'
    //   }
    // },
    {
      name: 'state',
      columnProps: {
        label: '还款状态',
        prop: 'state',
      },
      // 这里后端直接返回的文字
      tagProps: ({ row }) => { return { type: row.state === '已结清' ? 'success' : 'warning', text: row.state } },
      type: 'tag',
    },
    {
      name: 'dueDate',
      columnProps: {
        label: '应收日期',
        prop: 'dueDate',
        width: '100px',
      },
    },
    {
      name: 'completeTime',
      columnProps: {
        label: '实收日期',
        prop: 'completeTime',
        width: '100px',
      },
    },
    {
      name: 'contractEndDate',
      columnProps: {
        label: '合同到期时间',
        prop: 'contractEndDate',
        width: '120px',
      },
    },
  ]
  const personal = [
    {
      name: 'idCard',
      columnProps: {
        label: '身份证号',
        prop: 'idCard',
        width: '150px',
      },
    },
    {
      name: 'phone',
      columnProps: {
        label: '电话',
        prop: 'phone',
        width: '110px',
      },
    },
  ]

  if (customerType === 1) {
    columns.splice(2, 0, ...personal)
  }

  return {
    columns,
    summaryMap,
  }
}

export default config
